import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetClinicPartnerEnrolledPatientsArgs } from "../schemas/dashboard";

const getClinicPartnerEnrolledPatientsQueryKey = (args: GetClinicPartnerEnrolledPatientsArgs) =>
  ["getClinicPartnerEnrolledPatients", args] as const;

export const useGetClinicPartnerEnrolledPatients = (args: GetClinicPartnerEnrolledPatientsArgs) => {
  const client = useApiClient();

  return useQuery(getClinicPartnerEnrolledPatientsQueryKey(args), () => client.getClinicPartnerEnrolledPatients(args));
};
